import React from "react";
import { ValidationError } from "../validation-error";
import "./rectangular-switch-toggle.scss";

const baseClass = "rectangular-switch-toggle";

interface ValueOption {
  label: React.ReactNode;
  value: string | number;
}

interface RectangularSwitchToggleProps {
  values: ValueOption[];
  selectedValue: string | number;
  onChange: (value: string | number) => void;
  disabled?: boolean;
  error?: string;
  className?: string;
}

export const RectangularSwitchToggle: React.FC<
  RectangularSwitchToggleProps
> = ({
  values,
  selectedValue,
  onChange,
  disabled = false,
  error,
  className = "",
}) => {
  // When clicked, change selected to the clicked value if different
  const onToggle = (value: string | number) => {
    if (!disabled && value !== selectedValue) {
      onChange(value);
    }
  };

  return (
    <div
      className={`${baseClass} ${className} ${disabled ? `${baseClass}--disabled` : ""}`}
    >
      <div
        className={`${baseClass}__group ${error ? `${baseClass}__group--invalid` : ""}`}
        role="group"
        aria-disabled={disabled}
      >
        {values.map(({ label, value }) => {
          const isActive = value === selectedValue;
          return (
            <button
              key={value}
              type="button"
              className={`${baseClass}__option ${isActive ? `${baseClass}__option--active` : ""}`}
              onClick={() => onToggle(value)}
              disabled={disabled}
              aria-pressed={isActive}
            >
              {label}
            </button>
          );
        })}
      </div>
      {error && <ValidationError>{error}</ValidationError>}
    </div>
  );
};
